'use es6';

import http from 'hub-http/clients/apiClient';
/**
 * GET hub-locales/v2/i18n
 */

export function fetch() {
  return http.get('hub-locales/v2/i18n');
}